import React, { FC } from 'react';
import styled, { css } from 'styled-components/macro';

import media from 'helpers/media';

const Styles = css<{
    active?: boolean;
}>`
    display: flex;
    align-items: center;
    padding: 0 ${({ theme }) => theme.space.base};
    color: #fff;

    text-decoration: none;
    font-size: 1rem;
    font-weight: 500;

    &:hover {
        color: ${({ theme }) => theme.colors.brand} !important;
    }

    ${({ theme, active }) =>
        active &&
        css`
            color: ${theme.colors.brand} !important;
        `};

    ${({ theme }) => media.fromLaptop`
        .Dropdown_sc & {
            padding-top: ${theme.space.small};
            padding-bottom: ${theme.space.small};
            color: ${theme.colors.body};
        }
    `}

    ${({ theme }) => media.toTablet`
        padding: ${theme.space.small} ${theme.space.base};
        .Dropdown_sc > & {
            margin-left: ${theme.space.medium};
        } 
    `}
`;

const A = styled.a`
    ${Styles}
`;

const Span = styled.span`
    ${Styles}
`;

const NavigationItem: FC<
    {
        label?: string;
        active?: boolean;
        href?: string;
    } & React.HTMLAttributes<HTMLElement>
> = ({ active, label, href, ...rest }) => {
    return href ? (
        <A {...rest} active={active} href={href}>
            {rest.children || label}
        </A>
    ) : (
        <Span {...rest} active={active}>
            {rest.children || label}
        </Span>
    );
};

export default NavigationItem;
